import React, { useCallback, useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'

const nameRegEx = /^[-a-zA-Z\s]*$/

interface ICaptchaInputProps {
  value?: string
  onChange: (value: string) => void
  style?: React.CSSProperties
}

const CaptchaInput: React.FC<ICaptchaInputProps> = ({ value: valueProp, onChange, style }) => {
  const [value, setValue] = useState<string>('')
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    if (valueProp !== undefined) {
      const resultValue = valueProp.trim()
      const isValid_ = nameRegEx.test(resultValue) && resultValue.length > 5
      setIsValid(isValid_)
      onChange(resultValue)
      setValue(valueProp)
    }
  }, [valueProp, onChange])

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      const resultValue = value.trim()
      const isValid_ = nameRegEx.test(resultValue) && resultValue.length > 5
      setIsValid(isValid_)
      onChange(resultValue)
      setValue(value)
    },
    [onChange]
  )

  return (
    <Form.Group className={'mt-3'}>
      <Form.Control
        value={value}
        type='text'
        placeholder='Символы с картинки'
        maxLength={6}
        minLength={6}
        onChange={handleChange}
        style={style}
        className={isValid ? 'is-valid' : 'is-invalid'}
      />
      <div className='invalid-feedback' style={{ display: isValid ? 'none' : 'block' }}>
        {value.trim().length < 6
          ? 'Поле должно содержать не менее 6 символов'
          : 'Поле может содержать только латинские буквы'}
      </div>
    </Form.Group>
  )
}
export default CaptchaInput
